import { render, staticRenderFns } from "./JDate.vue?vue&type=template&id=573d7638&"
import script from "./JDate.vue?vue&type=script&lang=js&"
export * from "./JDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports